import type { SVGProps } from 'react';

const SvgClassD = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_669_26672)'>
      <path
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
        fill='#AE2DEC'
      />
      <path
        d='M11.7198 17.4047C11.0981 17.4025 10.5959 16.9017 10.5982 16.2864C10.6005 15.6712 11.1064 15.1742 11.728 15.1765C13.4948 15.183 14.9379 13.7653 14.9444 12.0166C14.9508 10.268 13.5183 8.83965 11.7515 8.83311L10.279 8.82767L10.2514 16.2852C10.2492 16.9004 9.74324 17.3974 9.1216 17.3951C8.49996 17.3928 7.99773 16.8921 8.00001 16.2768L8.03169 7.70521C8.03396 7.08996 8.53988 6.59293 9.16152 6.59522L11.7597 6.60482C14.7681 6.61594 17.2068 9.04748 17.1958 12.025C17.1848 15.0024 14.7282 17.4159 11.7198 17.4047Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_669_26672'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassD;
